import { AppliedRulesPanel } from "@/components/stats/applied-rules"
import { MatrixPanel } from "@/components/stats/matrix-panel"

/**
 * Вкладка Dashboard — порядок панелей как в образце: сначала статистика
 * применения правил, под ней матрица ошибок.
 *
 * Статистика — живая, из ClickHouse, тот же компонент, что на `/` (AMEND-78).
 * Матрица до появления разметки показывает пустое состояние, а не цифры.
 */
export function DashboardTab() {
  return (
    <div className="space-y-4">
      <AppliedRulesPanel />
      <MatrixPanel />
    </div>
  )
}
